<template>
    <div class="payments-home-icon">
        <i class="fa-solid fa-credit-card"></i>
    </div>
</template>

<script>
export default {
    props: {
        context: {
            type: Object
        }
    }
}
</script>

<style scoped>
.payments-home-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 18px;
    background: linear-gradient(135deg, #11998e, #38ef7d);
    font-size: 24px;
    color: #fff;
}
</style>